var content = (function (module) {
var css = { id: module.id, exports: {} };
(function (module) {
exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".manageEvents {\n  font-size: 15px;\n  justify-content: space-around;\n  display: flex;\n}\n\n.manageButton {\n  justify-content: space-around;\n  display: flex;\n}\n", "",{"version":3,"sources":["channel_notification.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,aAAa;AACf","file":"channel_notification.css","sourcesContent":[".manageEvents {\n  font-size: 15px;\n  justify-content: space-around;\n  display: flex;\n}\n\n.manageButton {\n  justify-content: space-around;\n  display: flex;\n}\n"]}]);


})(css);
return css.exports;
}) (module);
var loader = require("/home/ubuntu/trooprbot-ui/node_modules/antd-theme/lib/loadThemedStyles.js");

if(typeof content === "string") content = [[module.id, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;